<template>
  <div class="fill-width">
    <b-container class="m-0 p-0 direction-rtl" fluid>
      <b-row
        align-content="center"
        class="mt-2 d-flex justify-content-center"
        v-if="getMobileLayout"
      >
        <HeaderNewVersion />
        <b-row align-content="center" class="mt-2">
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-start pb-2"
          >
            <span class="font-size-medium new-title-color font-weight-bold">
              {{ $translate("mobilePhone") }}
            </span>
          </b-col>
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-center pb-2"
          >
            <b-form-input
              id="mobile-number-input"
              name="mobile-number-input"
              :placeholder="$translate('enterMobilePhoneNumber')"
              class="new-form-control mx-1 text-end py-2"
              pattern="\d*"
              inputmode="numeric"
              required
              v-model="mobileNumber"
              v-mask="'###########'"
              :state="mobileNumberValidation"
              :readonly="isPhoneNumberReceivedFromServer"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row align-content="center" class="mt-2">
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-start pb-2"
          >
            <span class="font-size-medium new-title-color font-weight-bold">
              {{ $translate("selectAmount") }}
            </span>
          </b-col>
          <b-col
            cols="12"
            align-self="center"
            class="d-flex justify-content-center"
          >
            <b-row
              cols="12 input-group direction-rtl m-0 pb-3"
              v-if="!isShetabAmountsReceivedFromServer"
            >
              <b-form-select
                class="new-form-control py-2 mx-1"
                v-model="selectedAmount"
                :options="options"
                required
              ></b-form-select>
            </b-row>
            <b-row
              v-if="
                isShetabAmountsReceivedFromServer &&
                getPayingAmount &&
                getPayingAmount.split(',').length === 1
              "
            >
              <b-col
                cols="12"
                class="pb-1 midnight-blue-text font-size-small font-weight-bold"
              >
                {{ $translate("payingAmount") }}
              </b-col>
            </b-row>
            <!--          if the paying amount was available on store -->
            <b-row
              cols="12"
              class="input-group direction-rtl m-0 pb-3"
              v-if="
                isShetabAmountsReceivedFromServer &&
                getPayingAmount &&
                getPayingAmount.split(',').length === 1
              "
            >
              <input
                :value="
                  $options.filters.commaSep(selectedAmount) +
                  $translate('toman')
                "
                readonly
                class="col-12 new-form-control mx-1 font-size-medium-small font-weight-bold py-2"
              />
            </b-row>
          </b-col>
        </b-row>
        <b-row align-content="center" class="mt-2 p-0 fill-width">
          <b-col cols="12" class="d-flex justify-content-center">
            <b-container class="card-container">
              <b-row
                class="fill-width d-flex justify-content-center card-loading-min-height"
                v-if="gettingUserCards"
              >
                <b-col
                  cols="12"
                  class="d-flex justify-content-center align-items-center"
                >
                  <b-spinner variant="primary"></b-spinner>
                </b-col>
              </b-row>

              <b-col
                cols="12"
                class="d-flex justify-content-center"
                v-if="!gettingUserCards"
              >
                <div
                  class="flicking-container d-flex justify-content-center fill-width dynamic-flicking-max-width position-relative"
                >
                  <FlickingSlider
                    ref="flickingSlider"
                    :userSavedCards="userSavedCards"
                    @getSelectedCardSlide="setCardSlide"
                    @getSavedCards="getUserCards('first')"
                    @openAddToCardModal="shetabAddToCardModalShow = true"
                  />
                </div>
              </b-col>
            </b-container>
          </b-col>
        </b-row>
        <b-row class="pb-4 mt-3">
          <b-col cols="4">
            <button type="button" class="decline-button" @click="cancelPayment">
              {{ $translate("cancel") }}
            </button>
          </b-col>
          <b-col cols="8">
            <button
              type="button"
              class="go-to-next-button"
              @click="submitInfoNewVersion"
              id="next-step-button"
            >
              <b-row class="fill-width">
                <b-col cols="10">{{ $translate("nextStep") }}</b-col>
                <b-col
                  cols="2"
                  class="p-0 d-flex justify-content-center align-items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </b-col>
              </b-row>
            </button>
          </b-col>
        </b-row>
      </b-row>

      <DesktopLayoutHelperNewVersion v-if="!getMobileLayout">
        <template v-slot:body>
          <b-container class="ml-0 my-1 mr-1 pl-0 py-1 pr-1" fluid>
            <b-row class="fill-width">
              <b-col
                cols="5"
                align-self="center"
                class="d-flex justify-content-center"
              >
                <!--              field body-->
                <b-row align-content="center" class="mt-2 fill-width">
                  <b-col
                    cols="12"
                    align-self="center"
                    class="d-flex justify-content-start pb-2"
                  >
                    <span
                      class="font-size-medium new-title-color font-weight-bold"
                    >
                      {{ $translate("mobilePhone") }}
                    </span>
                  </b-col>
                  <b-col
                    cols="12"
                    align-self="center"
                    class="d-flex justify-content-center pb-3"
                  >
                    <b-form-input
                      id="mobile-number-input"
                      name="mobile-number-input"
                      :placeholder="$translate('enterMobilePhoneNumber')"
                      class="new-form-control fill-height mx-1 text-end py-2"
                      pattern="\d*"
                      inputmode="numeric"
                      required
                      v-model="mobileNumber"
                      v-mask="'###########'"
                      :state="mobileNumberValidation"
                      :readonly="isPhoneNumberReceivedFromServer"
                    ></b-form-input>
                  </b-col>
                  <b-col
                    cols="12"
                    align-self="center"
                    class="d-flex justify-content-start pb-2"
                  >
                    <span
                      class="font-size-medium new-title-color font-weight-bold"
                    >
                      {{ $translate("selectAmount") }}
                    </span>
                  </b-col>
                  <b-col
                    cols="12"
                    align-self="center"
                    class="d-flex justify-content-center"
                  >
                    <b-row
                      cols="12 input-group direction-rtl m-0 pb-3"
                      v-if="!isShetabAmountsReceivedFromServer"
                    >
                      <b-form-select
                        class="new-form-control py-2"
                        v-model="selectedAmount"
                        :options="options"
                        required
                      ></b-form-select>
                    </b-row>
                    <b-row
                      v-if="
                        isShetabAmountsReceivedFromServer &&
                        getPayingAmount &&
                        getPayingAmount.split(',').length === 1
                      "
                    >
                      <b-col
                        cols="12"
                        class="pb-1 midnight-blue-text font-size-small font-weight-bold"
                      >
                        {{ $translate("payingAmount") }}
                      </b-col>
                    </b-row>
                    <!--          if the paying amount was available on store -->
                    <b-row
                      cols="12"
                      class="input-group direction-rtl m-0 pb-3"
                      v-if="
                        isShetabAmountsReceivedFromServer &&
                        getPayingAmount &&
                        getPayingAmount.split(',').length === 1
                      "
                    >
                      <input
                        :value="
                          $options.filters.commaSep(selectedAmount) +
                          $translate('toman')
                        "
                        readonly
                        class="col-12 new-form-control mx-1 font-size-medium-small font-weight-bold py-2"
                      />
                    </b-row>
                  </b-col>
                  <b-row class="pb-4 mt-3 pl-0">
                    <b-col cols="4">
                      <button
                        type="button"
                        class="decline-button"
                        @click="cancelPayment"
                      >
                        {{ $translate("cancel") }}
                      </button>
                    </b-col>
                    <b-col cols="8" class="pl-0">
                      <button
                        type="button"
                        class="go-to-next-button"
                        @click="submitInfoNewVersion"
                        id="next-step-button"
                      >
                        <b-row class="fill-width">
                          <b-col cols="10">{{ $translate("nextStep") }}</b-col>
                          <b-col
                            cols="2"
                            class="p-0 d-flex justify-content-center align-items-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="currentColor"
                              class="bi bi-arrow-left-short"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                              />
                            </svg>
                          </b-col>
                        </b-row>
                      </button>
                    </b-col>
                  </b-row>
                </b-row>
              </b-col>
              <b-col
                cols="7"
                align-self="center"
                class="d-flex justify-content-center px-1"
              >
                <b-row align-content="center" class="mt-2 p-0 fill-width">
                  <b-col cols="12" class="d-flex justify-content-center pl-0">
                    <b-container
                      class="card-container d-flex justify-content-center align-items-center pl-0"
                    >
                      <b-row
                        class="fill-width d-flex justify-content-center"
                        v-if="gettingUserCards"
                      >
                        <b-col
                          cols="12"
                          class="d-flex justify-content-center align-items-center"
                        >
                          <b-spinner variant="primary"></b-spinner>
                        </b-col>
                      </b-row>
                      <b-row
                        class="fill-width d-flex justify-content-center"
                        v-if="!gettingUserCards"
                      >
                        <b-col
                          cols="12"
                          class="d-flex justify-content-center ml-0 px-0"
                        >
                          <div
                            class="flicking-container d-flex justify-content-center position-relative fill-width dynamic-max-width"
                          >
                            <FlickingSlider
                              ref="flickingSlider"
                              :userSavedCards="userSavedCards"
                              :userCardVerificationReq="userCardVerificationReq"
                              @getSelectedCardSlide="setCardSlide"
                              @getSavedCards="getUserCards('first')"
                              @openAddToCardModal="
                                shetabAddToCardModalShow = true
                              "
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </DesktopLayoutHelperNewVersion>
    </b-container>
    <ShetabAddCartModal
      :visibility="shetabAddToCardModalShow"
      :userSavedCards="userSavedCards"
      @getSavedCards="newCardIsAdded"
      @closeModal="shetabAddToCardModalShow = false"
    />
    <TerminalVerificationModal
      :visibility="terminalVerificationModalShow"
      :terminalVerificationInfo="terminalVerificationInfo"
      :terminalVerificationIsPending="terminalVerificationIsPending"
      @getSavedCards="newCardIsAdded"
      @closeModal="terminalVerificationModalShow = false"
    />
  </div>
</template>

<script>
import { directBankMixin } from "@/mixins/ShetabMixins/DirectBankMixin";
import HeaderNewVersion from "@/components/HeaderNewVersion";
import { mapGetters, mapMutations } from "vuex";
import DesktopLayoutHelperNewVersion from "@/components/DesktopLayoutHelperNewVersion";
import ShetabAddCartModal from "@/components/Shetab/NewVersion/Modals/ShetabAddCartModal";
import FlickingSlider from "@/components/Shetab/NewVersion/Helper/FlickingSlider";
import TerminalVerificationModal from "./Modals/TerminalVerificationModal";
import alertHelper from "@/helper/AlertHelper";

export default {
  name: "DirectBankNewVersion",
  components: {
    TerminalVerificationModal,
    FlickingSlider,
    ShetabAddCartModal,
    DesktopLayoutHelperNewVersion,
    HeaderNewVersion,
  },
  mixins: [directBankMixin],
  data() {
    return {
      showFlicking: false,
      steppers: [1, 2, 3, 4],
      selectedCardSlide: 0,
      shetabAddToCardModalShow: false,
      terminalVerificationModalShow: false,
      gettingUserCards: false,
      userSavedCards: [],
      terminalVerificationInfo: {},
      terminalVerificationIsPending: false,
      userCardVerificationReq: false,
      submitInfoPrevent: false,
    };
  },
  computed: {
    ...mapGetters(["getMobileLayout"]),
  },
  methods: {
    ...mapMutations(["setSavedSelectedCardSlide"]),
    setCardSlide(selectedCardSlide) {
      this.selectedCardSlide = selectedCardSlide;
    },

    useThisCardFromCarousel(cardInfo) {
      // Split the card number into 4-character chunks
      const splitCardInfo = cardInfo?.to?.match(/.{1,4}/g);

      // Set the selected card slide
      this.setSavedSelectedCardSlide(this.selectedCardSlide);

      if (this.userCardVerificationReq) {
        if (cardInfo?.verified) {
          // If the card is verified, set the credit card information
          this.setCreditCardInfo(splitCardInfo);
          this.submitInfoPrevent = false;
        } else {
          // If the card is not verified, show an error message and clear the card number
          alertHelper.errorAlert("", "کارت انتخابی شما تایید نشده است");
          this.clearCreditCardInfo();
          // because we need to show the user this alert, the submit info function also
          //  has validation and will interrupt this alert
          this.submitInfoPrevent = true;
        }
      } else {
        // If no card verification is needed, set the credit card information
        this.setCreditCardInfo(splitCardInfo);
        this.submitInfoPrevent = false;
      }
    },

    setCreditCardInfo(splitCardInfo) {
      // set the credit card information with the split card number
      this.creditCardInfo.forEach((creditCard, i) => {
        creditCard.value = splitCardInfo[i];
      });
    },

    clearCreditCardInfo() {
      // Clear the credit card information
      this.creditCardInfo.forEach((creditCard) => {
        creditCard.value = "";
      });
    },

    checkWhichCardIsSelected() {
      //cardSlide number 0 is the add new card slide
      if (this.selectedCardSlide !== 0) {
        const i = this.selectedCardSlide - 1;
        if (i >= 0 && i < this.userSavedCards.length) {
          this.useThisCardFromCarousel(this.userSavedCards[i], i);
        }
      }
    },
    checkIfUserHasSavedCards(selectedCard) {
      const flickingSlider = this.$refs.flickingSlider;
      if (!flickingSlider) return;
      if (this.userSavedCards?.length > 0) {
        if (selectedCard === "first") {
          this.selectedCardSlide = 1;
          flickingSlider.moveFlicking("next");
        } else if (selectedCard === "last") {
          this.selectedCardSlide = this.userSavedCards?.length - 1;
          flickingSlider.moveFlicking("first");
        }
      }
      flickingSlider.refreshFlicking();
    },
    newCardIsAdded() {
      this.getUserCards("last");
    },

    submitInfoNewVersion() {
      this.checkWhichCardIsSelected();
      //execute after the previous function
      this.$nextTick(() => {
        if (!this.submitInfoPrevent) this.submitInfo();
      });
    },
    getUserCards(selectedCard) {
      const queryId = this.$route.query.id;
      this.gettingUserCards = true;
      //because it may cause some problems if queryId is used in this condition
      if (queryId) {
        this.$http.get(`payments/${queryId}/cards`).then(
          (result) => {
            this.userSavedCards = result.body.data;
            this.gettingUserCards = false;
            this.$nextTick(() => {
              this.checkIfUserHasSavedCards(selectedCard);
            });
          },
          (error) => {
            // alertHelper.apiErrorAlert("", error.body.message);
            console.log(error.body.message);
            this.gettingUserCards = false;
          }
        );
      }
    },
    getTerminalVerification() {
      const queryId = this.$route.query.id;
      //because it may cause some problems if queryId is used in this condition
      if (queryId) {
        this.$http.get(`payments/${queryId}/verification-terminal-info/`).then(
          (result) => {
            this.terminalVerificationInfo = result.body.data;
            const cardVerfReq =
              this.terminalVerificationInfo.verification_card_required;
            this.userCardVerificationReq = cardVerfReq;
            // const nationalIdReq =
            //   this.terminalVerificationInfo.verification_national_id_required;
            if (cardVerfReq) {
              this.getUserVerification();
            }
          },
          (error) => {
            // alertHelper.apiErrorAlert("", error.body.message);
            console.log(error.body.message);
          }
        );
      }
    },
    getUserVerification() {
      const queryId = this.$route.query.id;
      //because it may cause some problems if queryId is used in this condition
      if (queryId) {
        this.$http.get(`payments/${queryId}/verification-info/`).then(
          (result) => {
            const resultData = result.body.data;

            //if a prop was true (any prop)
            if (!resultData.verified_card) {
              this.terminalVerificationModalShow = true;
              // if it was not verified and pending was true:
              // this means that user has already requested and
              // needs to wait for the result
              this.terminalVerificationIsPending = resultData.pending;
            }
          },
          (error) => {
            // alertHelper.apiErrorAlert("", error.body.message);
            console.log(error.body.message);
          }
        );
      }
    },
  },

  mounted() {
    this.getUserCards("first");
    this.getTerminalVerification();
  },
};
</script>

<style scoped>
.card-loading-min-height {
  min-height: 15vh;
}
.dynamic-flicking-max-width {
  max-width: 90vw !important;
}
@media only screen and (max-width: 400px) {
  .dynamic-flicking-max-width {
    max-width: 88vw !important;
  }
}
.dynamic-max-width {
  max-width: 30vw !important;
}
@media only screen and (min-width: 1921px) {
  .dynamic-max-width {
    max-width: 26vw !important;
  }
}

.credit-card-input-background {
  background: #ffe5c7 !important;
}
.saved-card-input-background {
  background-color: #ffffff !important;
}

.card-container {
  width: 100%;
  display: flex;
  white-space: nowrap;
  padding: 5px;
}
.overflow-x-container::-webkit-scrollbar {
  width: 0; /* Hide the scrollbar for Chrome, Safari, and Opera */
  height: 0; /* Hide the scrollbar for Chrome, Safari, and Opera */
}

.add-new-card-container {
  background: linear-gradient(192deg, #ffd584 0%, #fab86b 100%);
  border-radius: 10px;
}

.decline-button {
  border-radius: 10px;
  background: #dedede;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  width: 100%;
  height: 40px;
  border: 1px solid lightgrey;
}
.go-to-next-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}
</style>
